import { ResponseStatus } from '@sdbn/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA   } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { Component, OnInit, Inject } from '@angular/core';
import { ResponseMessage } from '@sdbn/common';
import { SacClientService } from '../../../../service/sac-client.service';
import { SuspendStation } from '../../../../model/sac-client.model';

export class SuspendStationDialogData {
  stattionId: number;
}

@Component({
  selector: 'app-suspend-station-dialog',
  templateUrl: './suspend-station-dialog.component.html',
  styleUrls: ['./suspend-station-dialog.component.scss']
})
export class SuspendStationDialogComponent implements OnInit {

  isLoading = false;
  note = '';
  responseMessages: ResponseMessage[] = [];


  constructor(
    private sacClientService: SacClientService,
    public dialogRef: MatDialogRef<SuspendStationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SuspendStationDialogData,
    public translationService: TranslationService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  cancelDialog() {
    this.dialogRef.close();
  }

  public isSupendStationDisabled() {
    if (this.isLoading) {
      return true;
    }
    return this.note == null || this.note.length === 0;
  }

  public suspendStation() {
    this.isLoading = true;
    this.responseMessages = [];

    const suspension = new SuspendStation();
    suspension.stationId = this.data.stattionId;
    suspension.note = this.note;
    this.sacClientService.suspendStation(suspension).subscribe(response => {
      this.isLoading = false;
      if (response.status === ResponseStatus.SUCCESS) {
        this.dialogRef.close();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      this.isLoading = false;
      console.error('Error suspending station: ' + error);
    });
  }

}
